import { useEffect, useRef } from "react";
import { useState } from "react";

export const monthToString: { [m: number]: string } = {
  0: "january",
  1: "february",
  2: "march",
  3: "april",
  4: "may",
  5: "june",
  6: "july",
  7: "august",
  8: "september",
  9: "october",
  10: "november",
  11: "december",
};

export const dayToStringLong: { [d: number]: string } = {
  0: "sunday",
  1: "monday",
  2: "tuesday",
  3: "wednesday",
  4: "thursday",
  5: "friday",
  6: "saturday",
};

export const dayToStringShort: { [d: number]: string } = {
  0: "sun",
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
};

// Date -> 6:30am / 5:00pm format
export function dateToShortTime(date: Date) {
  const h = date.getHours();
  const m = date.getMinutes();
  const ampm = h >= 12 ? "pm" : "am";

  // Add leading zero to minutes if they are less than 10
  const formattedMinutes = m < 10 ? "0" + m : m;

  return `${h % 12 || 12}:${formattedMinutes}${ampm}`;
}

// Date -> "thu @ 6:30am"
export function dateToShortStr(date: Date) {
  return `${dayToStringShort[date.getDay()]} @ ${dateToShortTime(date)}`;
}

export function assertNever(_x: never): never {
  throw new Error("never");
}

export function useCurrentDate(intervalMs: number) {
  const [date, setDate] = useState(new Date());
  useEffect(() => {
    const interval = setInterval(() => {
      setDate(new Date());
    }, intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);
  return date;
}

export function formatMoney(amount: number) {
  return `$${amount.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
}

export function loadViaIframe(url: string): Promise<void> {
  return new Promise((resolve) => {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    iframe.onload = () => {
      document.body.removeChild(iframe);
      resolve();
    };
    iframe.onerror = () => {
      document.body.removeChild(iframe);
      resolve();
    };
    document.body.appendChild(iframe);
  });
}

export function usePrevious<T>(value: T) {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
